import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
  state: () => ({
    cart: null,
    orderSummary: null,
    tick: false,
    currentBreakpoint: null,
    dropdownWatcher: {},
    cookieOptedIn: false,
    adExpiry: null
  }),
  getters: {
    adsAllowed() {
      return this.adExpiry == null || Date.now() > this.adExpiry;
    }
  },
  actions: {
    setCart(payload) {
      this.cart = payload;
    },
    setOrderSummary(payload) {
      this.orderSummary = payload;
    },
    setCurrentBreakpoint(payload) {
      this.currentBreakpoint = payload;
    },
    bodyClick() {
      this.tick = !this.tick;
    },
    updateDropdownScope(payload) {
      this.dropdownWatcher[payload.scope] = payload.value;
    },
    deleteDropdownScope(scope) {
      delete this.dropdownWatcher[scope];
    },
    cookieOptIn() {
      this.cookieOptedIn = true;
    },
    expireAds(timestamp) {
      if (typeof timestamp == 'number') {
        this.adExpiry = Date.now() + timestamp * 1000;
      }
    }
  }
});
